//const ServerAPI = process.env.SERVER_API;
const ServerAPI = process.env.REACT_APP_SERVER_API;
//const ServerAPI2 = process.env.SERVER_API;
//const ServerFILE = "http://localhost:4000";
const ServerFILE = process.env.REACT_APP_SERVER_FILE;

//console.log('ServerAPI', process.env.REACT_APP_SERVER_API);



// export async function requestTokenApi (path: string, data: any) { 
    
//     try {
// 		const apiServer = (window.location.host === '127.0.0.1:3000')? 'http://127.0.0.1:3001' : ServerAPI;

// 		const response = await fetch(`${apiServer}/${path}`, {
// 			method: 'POST',
// 			headers: {
// 				'Content-Type': 'application/json',
// 				// 기타 필요한 헤더들 추가
// 			},
// 			credentials: 'include',
// 			body: JSON.stringify(data) // 요청 데이터(JSON 형식) 설정
// 		});
        
		
		
//         const returnData = await response.json();
        
//         return returnData;
//         //'return returnData;
//     } catch(error) {
//         throw new Error(`${error}`);
//     }
// };


export async function requestAPI (method: string, path: string, data: any) { return new Promise(async (resolve, reject) => {    

	try{
		const apiServer = ServerAPI;

		let response: any = null;
		let returnData: any = null;
		console.log(`${apiServer}/${path}`);
		// console.log(window.location.host);
		// console.log(apiServer);
		// console.log(path);

		switch (method) {
			case 'GET': 
				response = await fetch(`${apiServer}/${path}`,{
					credentials: 'include',
				});
				break;
			case 'POST': 
				response = await fetch(`${apiServer}/${path}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						// 기타 필요한 헤더들 추가
					},
					credentials: 'include',
					body: JSON.stringify(data) // 요청 데이터(JSON 형식) 설정
				});
				break;
			case 'FILE': 
				response = await fetch(`${ServerFILE}/${path}`, {
					method: 'POST',
					headers: {
					// 	//"accept-charset": "UTF-8"
					// 	//'Content-Type': 'application/json',
					// 	'Content-Type': 'charset=utf-8',
					// 	// 기타 필요한 헤더들 추가
						
					},
					//credentials: 'include',
					body: data
				});
				break;
			case 'FILE-REMOVE': 
				response = await fetch(`${ServerFILE}/${path}`, {
					method: 'POST',
					headers: {
					// 	//"accept-charset": "UTF-8"
						'Content-Type': 'application/json',
					// 	'Content-Type': 'charset=utf-8',
					// 	// 기타 필요한 헤더들 추가
					},
					//credentials: 'include',
					body: JSON.stringify(data) // 요청 데이터(JSON 형식) 설정
				});
				break;	
			case 'FILE-CP': 
				response = await fetch(`${ServerFILE}/${path}`, {
					method: 'POST',
					headers: {
						// "accept-charset": "UTF-8",
						// 'Content-Type': 'application/json',
						'Content-Type': 'application/json; charset=utf-8'
						//'Content-Type': 'charset=utf-8',
					// 	// 기타 필요한 헤더들 추가
					},
					//credentials: 'include',
					body: JSON.stringify(data) // 요청 데이터(JSON 형식) 설정
				});
				break;	

			case 'PUT': 
				response = await fetch(`${apiServer}/${path}`, {
					method: 'PUT',
					headers: {
						'Content-Type': 'application/json',
						// 기타 필요한 헤더들 추가
					},
					credentials: 'include',
					body: JSON.stringify(data) // 요청 데이터(JSON 형식) 설정
				});
				break;
			case 'DELETE': 
				response = await fetch(`${apiServer}/${path}`, {
					method: 'DELETE',
					headers: {
						'Content-Type': 'application/json',
						// 기타 필요한 헤더들 추가
					},
					credentials: 'include',
					body: JSON.stringify(data) // 요청 데이터(JSON 형식) 설정
				});
			break;
		}

		returnData = await response.json();

		//return returnData;

		resolve(returnData);
	} catch (err) {
		console.log('Catch Catch Catch')
		reject(0);
	}
});}